<template>
  <audio
    ref="audio"
    :class="previewClass"
    autoplay
    :src="previewData.preview_path"
    controls="controls"
  >您的浏览器不支持 audio 标签。</audio>
</template>

<script>
export default {
  name: "audioPreview",
  data() {
    return {};
  },
  created() {
    // console.log("初始化audioPreview预览组件");
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    }
  },
  destroyed() {
    // console.log("销毁audioPreview预览组件");
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview"
    });
  }
};
</script>

<style scoped>
.preview-fullscreen {
  width: 100%;
  height: 50%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 50%;
}
.preview-inside {
  width: 460px;
  height: 60px;
}
</style>